var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudent43(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M310.845+371.874L314.667+464.747L708.968+460.661L710.385+379.12",
    opacity: 1,
    fill: "#3c2210"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M876.999+915.886L183.402+915.886C165.861+915.886+152.367+901.685+153.262+884.167L167.853+598.697C167.853+527.055+232.424+483.214+281.359+478.515L413.788+469.661L622.622+469.234L747.281+478.515C808.61+483.214+860.787+527.055+860.787+598.697L876.999+915.886Z",
    fill: "#366e1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.722+112.506L519.278+112.506C617.868+112.506+697.791+203.338+697.791+315.386L697.791+315.386C697.791+427.433+617.868+518.266+519.278+518.266L511.722+518.266C413.131+518.266+333.208+427.433+333.208+315.386L333.208+315.386C333.208+203.338+413.131+112.506+511.722+112.506Z",
    opacity: 1,
    fill: "#dcad81"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#dcad81",
    d: "M513.641+350.256L518.054+350.256C575.632+350.256+622.309+400.324+622.309+462.085L622.309+462.085C622.309+523.847+575.632+573.914+518.054+573.914L513.641+573.914C456.062+573.914+409.386+523.847+409.386+462.085L409.386+462.085C409.386+400.324+456.062+350.256+513.641+350.256Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#3c2210",
    d: "M467.602+68.9528C476.995+69.752+482.98+68.8969+482.98+68.8969C703.324-55.933+855.415+524.07+676.839+457.723C676.839+457.723+729.668+164.938+515+164.197C300.332+163.456+352.78+457.424+352.78+457.424C160.468+528.454+335.503+57.7141+467.602+68.9528Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent43);
export default __webpack_public_path__ + "static/media/Student 43.f3a420b5c7fb087f45e95b12a87de257.svg";
export { ForwardRef as ReactComponent };